import {
  TweenMax,
  TimelineLite
} from 'gsap'

export default {
  name: 'work',
  data: function () {
    return {
      pNumber: 0,
      projects: [
        {
          category: 'Website',
          title: 'goTama',
          enContent: 'goTama strives to become a new standard for studying at universities. The challenge for this website was to let visitors understand the unique selling points of the web app.',
          deContent: 'Die App goTama möchte einen neuen Lernstandard an Universitäten setzen. Die Herausforderung bei der Entwicklung ihrer Webseite war es, Besuchern perfekt die Vorteile von goTama zu vermitteln.',
          url: 'http://gotama.rocks'
        },
        {
          category: 'Website',
          title: 'Bistro Thang Long',
          enContent: 'Together with the owners of this fine little restaurant located in Bernburg we created a new website. We dedicated special attention to the menu of the restaurant to give it a unique touch.',
          deContent: 'Zusammen mit den Besitzern dieses kleinen, feinen Restaurants entwickelten wir eine neue Webseite. Besonderen Fokus setzten wir hierbei auf das Speisemenü um es von anderen Restaurantseiten abzuheben.',
          url: 'http://bistro-thanglong.de/'
        },
        {
          category: 'Wordpress',
          title: 'Sei Dir Selbstbewusst',
          enContent: 'Laura Wällnitz is a remarkable motivation trainer and speaker. Together with her we worked on her personal branding and created this wordpress powered personal site and blog.',
          deContent: 'Laura Wällnitz ist eine herausragende Motivationstrainerin und Sprecherin. Wir arbeiteten mit ihr zusammen an ihrer persönlichen Marke und entwickelten ihre Wordpress Seite.',
          url: 'http://seidirselbstbewusst.com/'
        }
      ]
    }
  },
  computed: {
    english: function () {
      return this.$store.getters.english
    }
  },
  methods: {
    next: function () {
      if (window.innerWidth < 900) {
        if (this.pNumber < 2) {
          var tl = new TimelineLite({
            paused: true
          })
          tl.staggerTo([this.$refs.blend1, this.$refs.blend4, this.$refs.blend2, this.$refs.blend5, this.$refs.blend3], 0.3, {
              transform: 'translateX(0)',
              ease: Power1.easeOut
            }, 0.1)
            .staggerTo([this.$refs.blend3, this.$refs.blend5, this.$refs.blend1, this.$refs.blend4, this.$refs.blend2], 0.3, {
              transform: 'translateX(-100vw)',
              ease: Power1.easeOut
            }, 0.1)
            .to([this.$refs.blend3, this.$refs.blend5, this.$refs.blend1, this.$refs.blend4, this.$refs.blend2], 0, {
              transform: 'translateX(100vw)'
            })
            .to([this.$refs.object1], 0.3, {
              transform: 'translateX(-30px)',
              opacity: 0,
              ease: Power1.easeIn
            }, 0.1)
            .to([this.$refs.object2], 0.3, {
              transform: 'translateX(-30px)',
              opacity: 0,
              ease: Power1.easeIn
            }, 0.3)
            .to([this.$refs.object3], 0.3, {
              transform: 'translateX(-30px)',
              opacity: 0,
              ease: Power1.easeIn
            }, 0.4)
            .to([this.$refs.object1, this.$refs.object2, this.$refs.object3], 0, {
              transform: 'translateX(30px)',
              opacity: 0
            }, 0.5)
            .to([this.$refs.object1], 0.3, {
              transform: 'translateX(0)',
              opacity: 1,
              ease: Power1.easeOut
            }, 0.6)
            .to([this.$refs.object2], 0.3, {
              transform: 'translateX(0)',
              opacity: 1,
              ease: Power1.easeOut
            }, 0.8)
            .to([this.$refs.object3], 0.3, {
              transform: 'translateX(0)',
              opacity: 1,
              ease: Power1.easeOut
            }, 0.9)
          tl.play()

          setTimeout(() => this.pNumber++, 600)
        }
      } else {
        if (this.pNumber < 2) {
          var tl = new TimelineLite({
            paused: true
          })
          tl.staggerTo([this.$refs.blend1, this.$refs.blend4, this.$refs.blend2, this.$refs.blend5, this.$refs.blend3], 0.3, {
              transform: 'translateX(0)',
              ease: Power1.easeOut
            }, 0.1)
            .staggerTo([this.$refs.blend3, this.$refs.blend5, this.$refs.blend1, this.$refs.blend4, this.$refs.blend2], 0.3, {
              transform: 'translateX(-50vw)',
              ease: Power1.easeOut
            }, 0.1)
            .to([this.$refs.blend3, this.$refs.blend5, this.$refs.blend1, this.$refs.blend4, this.$refs.blend2], 0, {
              transform: 'translateX(50vw)'
            })
            .to([this.$refs.object1], 0.3, {
              transform: 'translateX(-30px)',
              opacity: 0,
              ease: Power1.easeIn
            }, 0.1)
            .to([this.$refs.object2], 0.3, {
              transform: 'translateX(-30px)',
              opacity: 0,
              ease: Power1.easeIn
            }, 0.3)
            .to([this.$refs.object3], 0.3, {
              transform: 'translateX(-30px)',
              opacity: 0,
              ease: Power1.easeIn
            }, 0.4)
            .to([this.$refs.object1, this.$refs.object2, this.$refs.object3], 0, {
              transform: 'translateX(30px)',
              opacity: 0
            }, 0.5)
            .to([this.$refs.object1], 0.3, {
              transform: 'translateX(0)',
              opacity: 1,
              ease: Power1.easeOut
            }, 0.6)
            .to([this.$refs.object2], 0.3, {
              transform: 'translateX(0)',
              opacity: 1,
              ease: Power1.easeOut
            }, 0.8)
            .to([this.$refs.object3], 0.3, {
              transform: 'translateX(0)',
              opacity: 1,
              ease: Power1.easeOut
            }, 0.9)
          tl.play()
          setTimeout(() => this.pNumber++, 600)
        }
      }
    },
    prev: function () {
      if (window.innerWidth < 900) {
        if (this.pNumber > 0) {
          var tl = new TimelineLite({
            paused: true
          })
          tl.to([this.$refs.blend3, this.$refs.blend5, this.$refs.blend1, this.$refs.blend4, this.$refs.blend2], 0, {
              transform: 'translateX(-100vw)'
            })
            .staggerTo([this.$refs.blend1, this.$refs.blend4, this.$refs.blend2, this.$refs.blend5, this.$refs.blend3], 0.3, {
              transform: 'translateX(0)',
              ease: Power1.easeOut
            }, 0.1)
            .staggerTo([this.$refs.blend3, this.$refs.blend5, this.$refs.blend1, this.$refs.blend4, this.$refs.blend2], 0.3, {
              transform: 'translateX(100vw)',
              ease: Power1.easeOut
            }, 0.1)
            .to([this.$refs.blend3, this.$refs.blend5, this.$refs.blend1, this.$refs.blend4, this.$refs.blend2], 0, {
              transform: 'translateX(100vw)'
            })
            .to([this.$refs.object1], 0.3, {
              transform: 'translateX(30px)',
              opacity: 0,
              ease: Power1.easeIn
            }, 0.1)
            .to([this.$refs.object2], 0.3, {
              transform: 'translateX(30px)',
              opacity: 0,
              ease: Power1.easeIn
            }, 0.3)
            .to([this.$refs.object3], 0.3, {
              transform: 'translateX(30px)',
              opacity: 0,
              ease: Power1.easeIn
            }, 0.4)
            .to([this.$refs.object1, this.$refs.object2, this.$refs.object3], 0, {
              transform: 'translateX(-30px)',
              opacity: 0
            }, 0.5)
            .to([this.$refs.object1], 0.3, {
              transform: 'translateX(0)',
              opacity: 1,
              ease: Power1.easeOut
            }, 0.6)
            .to([this.$refs.object2], 0.3, {
              transform: 'translateX(0)',
              opacity: 1,
              ease: Power1.easeOut
            }, 0.8)
            .to([this.$refs.object3], 0.3, {
              transform: 'translateX(0)',
              opacity: 1,
              ease: Power1.easeOut
            }, 0.9)
          tl.play()

          setTimeout(() => this.pNumber--, 600)
        }
      } else {
        if (this.pNumber > 0) {
          var tl = new TimelineLite({
            paused: true
          })
          tl.to([this.$refs.blend3, this.$refs.blend5, this.$refs.blend1, this.$refs.blend4, this.$refs.blend2], 0, {
              transform: 'translateX(-50vw)'
            })
            .staggerTo([this.$refs.blend1, this.$refs.blend4, this.$refs.blend2, this.$refs.blend5, this.$refs.blend3], 0.3, {
              transform: 'translateX(0)',
              ease: Power1.easeOut
            }, 0.1)
            .staggerTo([this.$refs.blend3, this.$refs.blend5, this.$refs.blend1, this.$refs.blend4, this.$refs.blend2], 0.3, {
              transform: 'translateX(50vw)',
              ease: Power1.easeOut
            }, 0.1)
            .to([this.$refs.blend3, this.$refs.blend5, this.$refs.blend1, this.$refs.blend4, this.$refs.blend2], 0, {
              transform: 'translateX(50vw)'
            })
            .to([this.$refs.object1], 0.3, {
              transform: 'translateX(30px)',
              opacity: 0,
              ease: Power1.easeIn
            }, 0.1)
            .to([this.$refs.object2], 0.3, {
              transform: 'translateX(30px)',
              opacity: 0,
              ease: Power1.easeIn
            }, 0.3)
            .to([this.$refs.object3], 0.3, {
              transform: 'translateX(30px)',
              opacity: 0,
              ease: Power1.easeIn
            }, 0.4)
            .to([this.$refs.object1, this.$refs.object2, this.$refs.object3], 0, {
              transform: 'translateX(-30px)',
              opacity: 0
            }, 0.5)
            .to([this.$refs.object1], 0.3, {
              transform: 'translateX(0)',
              opacity: 1,
              ease: Power1.easeOut
            }, 0.6)
            .to([this.$refs.object2], 0.3, {
              transform: 'translateX(0)',
              opacity: 1,
              ease: Power1.easeOut
            }, 0.8)
            .to([this.$refs.object3], 0.3, {
              transform: 'translateX(0)',
              opacity: 1,
              ease: Power1.easeOut
            }, 0.9)
          tl.play()

          setTimeout(() => this.pNumber--, 600)
        }
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/legal/legal.js